import React from 'react';
import { AlertTriangle } from '@saleshandy/icons';

type ScheduleValidationBannerProps = {
  message: string;
};

const ScheduleValidationBanner: React.FC<ScheduleValidationBannerProps> = ({
  message,
}) => (
  <div className="bs-schedule-form__error-banner" role="alert">
    <AlertTriangle width={14} height={14} color="#DC2626" />
    <span className="regular-2 gray-txt-9">{message}</span>
  </div>
);

export default ScheduleValidationBanner;
